module.exports = __webpack_public_path__ + "static/media/close-light.13cb7fd3.svg";